import { useState } from "react";

const useSelectedItem = () => {
  const [selectedTreeItem, setSelectedTreeItem] = useState("");

  return { selectedTreeItem, setSelectedTreeItem };
};

export default useSelectedItem;
